import React from 'react'
import LuxPlusExperienceDiscountOfferBanner from './components/LuxPlusExperienceDiscountOfferBanner'
import LuxPlusExperienceDiscountTakeoverBackground from './components/LuxPlusExperienceDiscountTakeoverBackground'
import {
  LUX_PLUS_EXPERIENCE_DISCOUNT_CAMPAIGN_ID,
  LUX_PLUS_EXPERIENCE_DISCOUNT_TAKEOVER_ID,
} from './constants/luxPlusExperienceDiscountTakeoverConstants'

const luxPlusExperienceDiscountTakeoverConfig: App.SiteTakeoverConfig = {
  id: LUX_PLUS_EXPERIENCE_DISCOUNT_TAKEOVER_ID,
  campaignTags: new Set([LUX_PLUS_EXPERIENCE_DISCOUNT_CAMPAIGN_ID]),
  verticals: new Set(['home', 'hotel', 'tours', 'cruise']),
  offerTypes: new Set([
    'hotel',
    'cruise',
    'tour', // Tour V1
    'direct_tour', 'partner_tour', 'connection_tour', // Tour V2
    'experience',
  ]),
  backgroundElement: LuxPlusExperienceDiscountTakeoverBackground,
  palette: 'inverse',
  siteWide: {
    banner: {
      description: <LuxPlusExperienceDiscountOfferBanner withCta />,
      align: 'start',
      logo: undefined,
      exceptedRoutes: ['/:regionCode/lux-plus'],
      hideOnOfferPagesForMobileScreenSize: true,
      showOnHomePage: true,
    },
  },
}

export default luxPlusExperienceDiscountTakeoverConfig
